import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------
//  SETUP FONTS

const Font =
{
    Header: 12,
    SubHeader: 10,
    Typos : '0.7rem'
}

// SETUP COLORS

const GREY = {
    0: '#FFFFFF',
    100: '#FFF9F9',
    //  100: '#fafafa',
    200: '#FBF0F0',
    300: '#C5BFBF',
    400: '#A8A2A2',
    500: '#8B8484',
    600: '#6E6767',
    700: '#514A4A',
    800: '#342D2D',
    900: '#171010',
};

const PRIMARY = {
    lighter: '#FFEFEF',
    light: '#FF5932',
    main: '#D51900',
    dark: '#A12816',
    darker: '#300904',
    contrastText: '#fff',
};

const SECONDARY = {
    lighter: '#D6E4FF',
    light: '#84A9FF',
    main: '#3366FF',
    dark: '#1939B7',
    darker: '#091A7A',
    contrastText: '#fff',
};

const INFO = {
    lighter: '#EDEDFF',
    light: '#C7C7FF',
    main: '#3333FE',
    dark: '#030384',
    darker: '#02023A',
    contrastText: '#fff',
};

const SUCCESS = {
    lighter: '#D8FBDE',
    light: '#86E8AB',
    main: '#00C974',
    dark: '#00653A',
    darker: '#00321D',
    contrastText: GREY[800],
};

const WARNING = {
    lighter: '#FFF5CC',
    light: '#FFD666',
    main: '#FFAB00',
    dark: '#B76E00',
    darker: '#7A4100',
    contrastText: GREY[800],
};

const ERROR = {
    lighter: '#FFEBEE',
    light: '#FFA3B1',
    main: '#FF195A',
    dark: '#7E0023',
    darker: '#3C0212',
    contrastText: '#fff',
};

const COMMON = {
    common: { black: '#000', white: '#fff' },
    primary: PRIMARY,
    secondary: SECONDARY,
    info: INFO,
    success: SUCCESS,
    warning: WARNING,
    error: ERROR,
    grey: GREY,
    font :Font,
    divider: alpha(GREY[500], 0.24),
    action: {
        hover: alpha(GREY[500], 0.08),
        selected: alpha(GREY[500], 0.16),
        disabled: alpha(GREY[500], 0.8),
        disabledBackground: alpha(GREY[500], 0.24),
        focus: alpha(GREY[500], 0.24),
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};

export default function palette(themeMode) {
    const light = {
        ...COMMON,
        mode: 'light',
        text: {
            main:'#D51900',
            primary: GREY[800],
            secondary: GREY[600],
            disabled: GREY[500],
        },
        background: { paper: '#fff', default: '#fff', neutral: GREY[200] },
        action: {
            ...COMMON.action,
            active: GREY[600],
        },
    };

    const dark = {
        ...COMMON,
        mode: 'dark',
        text: {
            primary: '#fff',
            secondary: GREY[500],
            disabled: GREY[600],
        },
        background: {
            paper: GREY[800],
            default: GREY[900],
            neutral: alpha(GREY[500], 0.16),
        },
        action: {
            ...COMMON.action,
            active: GREY[500],
        },
    };

    return themeMode === 'light' ? light : dark;
}
